export enum RefundStatus {
  None = 'NONE',
  Applying = 'APPLYING',
  Reviewing = 'REVIEWING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Refunding = 'REFUNDING',
  Refunded = 'REFUNDED',
  Closed = 'CLOSED',
}

export const REFUND_STATUS_LABELS: Record<RefundStatus, string> = {
  [RefundStatus.None]: '无售后',
  [RefundStatus.Applying]: '申请中',
  [RefundStatus.Reviewing]: '审核中',
  [RefundStatus.Approved]: '审核通过',
  [RefundStatus.Rejected]: '已驳回',
  [RefundStatus.Refunding]: '退款中',
  [RefundStatus.Refunded]: '已退款',
  [RefundStatus.Closed]: '已关闭',
}
